export default __webpack_public_path__ + "static/media/pump-jack.e45eeded.gif";